<!-- eslint-disable -->
<template lang="pug">
    .play-box.matrix-game-container(
        :class="{\
            'matrix-game-container_before-start': gameFinished,\
            'play-box_limited': parameters && parameters.difficult.amountOfRows <= 6\
        }"
    )
        .warning(v-if='isNeedToChangeDevice')
            svg#rotate(
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                x='0px' y='0px' width='40px'
                height='40px' viewbox='0 0 612 612'
                style='enable-background:new 0 0 612 612;'
                xml:space='preserve'
            )
                no-phone-icon
            div
                | {{ $i18n.t('trainer.trainer_gameFormSetting_changeDevice') }}
        .warning(v-if='isNeedToRotateDevice')
            svg#rotate(
                    version='1.1'
                    xmlns='http://www.w3.org/2000/svg'
                    x='0px' y='0px' width='40px'
                    height='40px' viewbox='0 0 612 612'
                    style='enable-background:new 0 0 612 612;'
                    xml:space='preserve'
                )
                no-phone-icon
            div
                | {{ $i18n.t('detective.detective_mobile_rotateText') }}
        template(v-if='!isNeedToRotateDevice && !isNeedToChangeDevice && !isLoading')
            game-header(
                v-if='!gameFinished && !hideGameHeader'
                :time='getTime'
                :slug='type'
                :game-type='parameters && parameters.courseType'
                @soundStateChanged ="headerKey = !headerKey"
                :key="headerKey"
                :is-homework="!!exerciseId"
            )
            .matrix-game-container__prepare-image(v-if='prepareForGame')
                game-preparation-counter(:counter="counter")
            .matrix-game-container__interactive-place(
                v-if='!prepareForGame'
                :class="interactivePlaceClass"
            )
                .matrix-game-container__interactive-place_table-with-button(
                    v-if="!gameFinished"
                    :class="interactivePlaceWithButtonClass"
                )
                    matrix-table(
                        v-if='!gameFinished'
                        :window-width='windowWidth'
                        :matrix-table='matrixTable'
                        :game-started='gameStarted'
                        :links-type='typeOfLinksInChain'
                        :drag-started='dragStarted'
                        :helper-mode-on='helperModeOn'
                        :table-size='parameters.difficult'
                        :link-dropped='linkDropped'
                        @processReply='processReply'
                        @displayPlayButton='showPlayButton = true'
                        @dropItemInMatrix='dropItemInMatrix'
                        @linkResized='linkDropped = false'
                        @dragStarted="isDragging = true"
                        @dragEnded="isDragging = false"
                    )
                    .buttons(v-if='!gameFinished' :class="{'buttons_without-top-padding': gameStarted}")
                        cs-button.matrix__button(
                            v-if="gameStarted && typeOfLinksInChain !== 'image' && !helperModeOn && !isOlympiad"
                            color="blue"
                            @click='showCorrectAnswers'
                            :disabled='!disableReplyButton'
                        )
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_forgot') }}
                        cs-button.matrix__button#reply-button(v-if='gameStarted && !helperModeOn' color="blue" :disabled='disableReplyButton' @click='processReply')
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                .buttons(v-if='!gameFinished' :class="{'buttons_without-top-padding': gameStarted}")
                    cs-button.matrix__button.start-game-button(
                        v-if='showStartGameButton'
                        color="blue"
                        @click='startGame'
                    )
                        | {{ $i18n.t('trainer.trainer_browseGames_play') }}
                    cs-button.matrix__button(v-if='helperModeOn' color="blue" @click='processReply')
                        | {{ memorizedButtonName }}
                drop.play-box__drop(@drop='dropItemInAnswersBox' v-if='!gameFinished && showAnswersContainer')
                    answer-container(
                        v-show="displayAnswersContainer"
                        :answers='itemsForAnswersBox'
                        :game-started='gameStarted'
                        :links-type='typeOfLinksInChain'
                        @dragStarted='dragStarted = true'
                        @dragEnded='dragStarted = false'
                    )
                fireworks(v-if='gameFinished && !isOlympiad && !prepareForGame' :is-mobile='isMobile')
                .matrix-game-container__result-container(v-if='gameFinished && !isOlympiad')
                    result-image.matrix-game-container__result-image(status="success")
                    result-buttons(
                        :exercise-id="exerciseId"
                        games-type="fastReading"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
        cs-loader(v-if="isLoading && !isNeedToChangeDevice")
</template>

<script>
    /*eslint-disable*/
    import MatrixApi from "../../../../api/games/matrix";
    import { Drop } from 'vue-drag-drop';
    import _ from "lodash";
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import MatrixTable from './MatrixTable.vue'
    import AnswerContainer from './AnswerContainer.vue'
    import GamePreparationCounter from "../../GamePreparationCounter.vue";
    import {mapState} from "vuex";

    const CORRECT_LINK = 'correct-link';
    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA () {
        return {
            matrixTable: [],
            itemsForAnswersBox: [],
            correctMatrix: [],
            typeOfLinksInChain: '',
            memorized: false,
            showPlayButton: false,
            chainOfAttempts: [],
            allInputsAreFilled: false,
            dragStarted: false,
            helperModeOn: false,
            prepareForGame: true,
            amountOfExamples: 0,
            hideGameHeader: false,
            isAttemptCorrect: false,
            linkDropped: false,
            isDragging: false,
            isFetched: false,
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin],
        data () {
            return DEFAULT_DATA();
        },
        watch: {
            matrixTable: {
                handler (matrixTable) {
                    if (this.typeOfLinksInChain !== 'image') {
                        let allInputsAreFilled = _.find(_.flatten(matrixTable), link => _.trim(link.value).length === 0);
                        this.allInputsAreFilled = allInputsAreFilled === undefined;
                    }
                },
                deep: true,
                immediate: true
            },
        },
        updated() {
            !this.isNeedToChangeDevice && !this.isFetched && this.fetchData();
        },
        methods: {
            fetchData () {
                this.isFetched = true;
                this.getExercise()
                .then(() => {
                    this.getExample();
                    this.registerSounds();
                })
                .catch(err => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                });
            },
            beforeStart () {
                this.prepareForGame = false;
                if (!this.timer) {
                    this.setTimer();
                }
                this.parameters.withTime && this.showMatrixTable();
            },
            dropItemInMatrix (index) {
                this.itemsForAnswersBox.splice(index, 1);
                this.isDragging = false;
            },
            getExample () {
                this.isLoading = true;
                let paramsForRequest = {
                    viewType: this.parameters.viewType,
                    amountOfCells: this.parameters.difficult.amountOfRows * this.parameters.difficult.amountOfColumns,
                    locale: this.user.locale,
                    difficultWords: false
                };
                MatrixApi.getMatrixByRequest(paramsForRequest)
                .then(elements => {
                    this.matrixTable = Object.values(elements).map((element, elementIndex) =>
                            elements.splice(0, this.parameters.difficult.amountOfColumns)
                    ).filter(row => Array.isArray(row) && row.length > 0).map(row =>
                            row.map((link, linkIndex) => {
                                if (this.parameters.mode === 'column' && linkIndex === 0) {
                                    link.type = CORRECT_LINK
                                }
                                return link;
                            })
                    );
                    this.correctMatrix = this.matrixTable;
                    this.typeOfLinksInChain = this.matrixTable[2][2].type;
                    this.isLoading = false;
                })
                .catch(err => this.showErrorMessage(err));
                if (!this.timer && !this.prepareForGame) {
                    this.setTimer();
                }
            },
            refreshGameStatBeforeSend () {
                this.gameStat.chainOfAttempts = this.chainOfAttempts;
                this.gameStat.attempts = this.chainOfAttempts.length;
                this.gameStat.answers = this.goodAnswers;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            calculatePercent () {
                let total = this.goodAnswers + this.badAnswers;
                if (total > 0) {
                    return parseInt(this.goodAnswers / (total) * 100);
                }
                return 0;
            },

            processReply () {
                let elemOfAttempt = {
                    good: 0,
                    bad: 0
                };
                this.matrixTable.forEach((row, rowIndex) => {
                    row.forEach((link, linkIndex) => {
                        if (link.type !== CORRECT_LINK) {
                            if (!link.helpMarker && this.isCorrectLink(this.correctMatrix[rowIndex][linkIndex], this.matrixTable[rowIndex][linkIndex])) {
                                this.correctMatrix[rowIndex][linkIndex].type = CORRECT_LINK;
                                !this.isOlympiad && (this.matrixTable[rowIndex][linkIndex].type = CORRECT_LINK);
                                elemOfAttempt.good++;
                            } else {
                                elemOfAttempt.bad++;
                            }
                        }
                    })
                })
                this.chainOfAttempts.push(elemOfAttempt);
                this.helperModeOn = false;
                if (_.flatten(this.matrixTable).filter(link => link.type === CORRECT_LINK).length === _.flatten(this.correctMatrix).length) {
                    this.isAttemptCorrect = true;
                    this.hideGameHeader = true;
                    if (this.amountOfExamples === 0) {
                        this.matrixDone();
                        return;
                    }
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    this.resetData();
                    return;
                }
                if (!this.isOlympiad) {
                    this.dropMatrixInAnswerBox();
                }
                if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                    this.isAttemptCorrect = false;
                    this.sendStat();
                }
            },
            resetData () {
                this.hideGameHeader = false;
                this.gameStarted = false;
                this.memorized = false;
                this.stopTimer();
                this.timer = null;
                this.itemsForAnswersBox = [];
                this.matrixTable = [];
                this.correctMatrix = [];
                if (this.answerTimer) {
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
            },
            isCorrectLink (originalLink, userLink) {
                if (this.typeOfLinksInChain === 'image') {
                    return originalLink.id === userLink.id;
                } else {
                    originalLink.value = originalLink.value.toLowerCase();
                    userLink.value = userLink.value.toLowerCase();
                    return _.trim(originalLink.value) === _.trim(userLink.value);
                }
            },
            matrixDone () {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play("gameDone");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            startGame () {
                this.memorized = !this.memorized;
                this.gameStarted = true;
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
                this.dropMatrixInAnswerBox();
            },
            dropMatrixInAnswerBox () {
                this.linkDropped = true;
                this.itemsForAnswersBox = _.shuffle(_.flatten(this.correctMatrix).filter(item => item.type !== CORRECT_LINK));
                let typeForEmptyCell = this.parameters.viewType === 'image' ? 'dropZone' : 'textInput';
                this.matrixTable = this.matrixTable.map(row => row.map((link, linkIndex) => {
                    if (this.parameters.mode === 'column' && linkIndex === 0) {
                        link.type = CORRECT_LINK;
                    } else if (link.type !== CORRECT_LINK) {
                        link = {
                            type: typeForEmptyCell,
                            value: ''
                        };
                    }
                    return link;
                }));
                this.$nextTick(this.shakeAnswerBlocks);
            },
            shakeAnswerBlocks () {
                let answerBlocks = document.getElementsByClassName('answer');
                let amount = answerBlocks.length;
                let timeouts = [];
                for (let i = 0; i < amount; i++) {
                    timeouts.push(setTimeout(() => {
                        answerBlocks[i].classList.add('shake');
                    }, i * 100));
                }
                setTimeout(() => {
                    for(let j = 0; j < timeouts.length; j++) {
                        clearTimeout(timeouts[j]);
                    }
                    for (let i = 0; i < amount; i++) {
                        if (answerBlocks[i]) {
                            answerBlocks[i].classList.remove('shake');
                        }
                    }
                }, 2000)
            },
            dropItemInAnswersBox (link) {
                this.linkDropped = true;
                if (link && link.from !== 'answers-box') {
                    let item = _.cloneDeep(link.item);
                    let dragEvent = arguments[arguments.length - 1];
                    let toDropIndex = dragEvent.srcElement.dataset.index;
                    if (toDropIndex) {
                        this.itemsForAnswersBox.splice(toDropIndex, 0, item);
                    } else {
                        if (dragEvent.srcElement.childElementCount) {
                            toDropIndex = dragEvent.srcElement.children[0].dataset.index;
                            toDropIndex && this.itemsForAnswersBox.splice(toDropIndex, 0, item);
                        }
                        !toDropIndex && this.itemsForAnswersBox.push(item);
                    }
                    this.$set(this.matrixTable[link.rowIndex], link.index, {type: 'dropZone'});
                }
            },
            showCorrectAnswers () {
                for (let rowIndex = 0; rowIndex < this.matrixTable.length; rowIndex++) {
                    for (let index = 0; index < this.matrixTable[rowIndex].length; index++) {
                        if (!_.trim(this.matrixTable[rowIndex][index].value)) {
                            this.$set(this.matrixTable[rowIndex], index, _.cloneDeep(this.correctMatrix[rowIndex][index]));
                            this.matrixTable[rowIndex][index].helpMarker = true;
                        } else {
                            this.matrixTable[rowIndex][index].type = this.correctMatrix[rowIndex][index].type;
                            this.matrixTable[rowIndex][index].helpMarker = false;
                        }
                    }
                }
                this.helperModeOn = true;
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            },
            showMatrixTable() {
                if (!this.showPlayButton && !this.gameStarted) {
                    setTimeout(() => {
                        this.startGame()
                    }, this.parameters.showTime * 1000)
                }
            }
        },
        computed: {
            ...mapState({
                amountOfColumns(state) {
                    return (
                        (state.trainer.game?.slug === 'Matrix' &&
                            state.trainer.game?.difficult.amountOfColumns) ||
                        this.battleGameParameters.parameters.default.difficult.amountOfColumns
                    );
                },
            }),
            showStartGameButton () {
                return !this.gameStarted && !this.parameters.withTime;
            },
            isNeedToRotateDevice() {
                return  !this.isNeedToChangeDevice && this.amountOfColumns >= 5 && this.windowWidth < 768 && this.windowHeight >= 768;
            },
            isNeedToChangeDevice () {
                return this.windowWidth < 768 && this.windowHeight < 768 && this.amountOfColumns >= 5;
            },
            goodAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(attempt => count += attempt.good);
                return count;
            },
            badAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(attempt => count += attempt.bad);
                return count;
            },
            memorizedButtonName () {
                return this.$i18n.t('trainer.trainer_gamePlayBox_memorizedButton', {
                    mode: this.$i18n.t('trainer.trainer_gamePlayBox_memorizedButton_all')
                });
            },
            allLinksNotSettled () {
                return this.typeOfLinksInChain === 'image' ? this.itemsForAnswersBox.length !== 0 : false;
            },
            disableReplyButton () {
                return this.allLinksNotSettled || !this.allInputsAreFilled;
            },
            showAnswersContainer () {
                return this.typeOfLinksInChain === 'image' && this.gameStarted;
            },
            interactivePlaceClass() {
                return window.innerWidth > 1439
                        && this.parameters.difficult.amountOfRows === 10 && !this.gameStarted
                        && 'matrix-game-container__interactive-place_10-10';
            },
            interactivePlaceWithButtonClass() {
                return window.innerWidth > 1439
                        && this.parameters.difficult.amountOfRows === 10 && !this.gameStarted
                        && 'matrix-game-container__interactive-place_table-with-button_10-10';
            }
        },
        components: {
            AnswerContainer,
            MatrixTable,
            Drop,
            GamePreparationCounter
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .buttons {
        text-align: center;
        padding: 10px 0;
        @include media($xlg) {
            align-self: center;
        }
        &_without-top-padding {
            padding-top: 0;
        }
        :first-child {
            margin-right: 20px;
        }
        .matrix__button {
            margin-top: 10px;
            font-weight: 500 !important;
        }
    }

    .matrix-game-container__interactive-place {
        margin: 0;
        flex: 1 1 auto;
        width: 100%;
        display: inline-flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .matrix-game-container__interactive-place_10-10 {
        flex-direction: row;
        justify-content: center;
    }

    .matrix-game-container {
        width: 100%;
        height: 100%;
        display: flex;
        overflow: hidden;
    }

    .matrix-game-container__prepare-image {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
    }

    .matrix-game-container__prepare-text {
        font-size: 60px;
        white-space: nowrap;
    }

    .matrix-game-prepare_before-start {
        justify-content: space-around;
    }

    .matrix-game-container__result-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: auto 0;
    }

    .matrix-game-container__result-image {
        @include stack-space($space-base);
        max-width: 450px;
        max-height: 450px;
        vertical-align: middle;
    }

    .matrix-game-container__interactive-place_table-with-button {
        //height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        @include media ($xlg) {
            flex-direction: row;
            align-items: flex-start;
        }
    }

    .matrix-game-container__interactive-place_table-with-button_10-10 {
        width: initial;
    }

    .matrix__buttons-container {
        display: flex;
        justify-content: center;
        text-align: center;
        margin-top: 20px;
    }

    .matrix__link {
        @media screen and (max-width: 640px) {
            display: block;
            width: 100%;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .matrix__button {
        @media screen and (max-width: 640px) {
            width: 100%;
        }
    }

    .warning {
        display: flex;
        text-align: center;
        flex-direction: column;
        align-items: center;
    }

    .with-warning {
        display: table;
    }

    @import '@/assets/sass/animations/shake.scss';

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__drop {
        display: flex;
        justify-content: center;
        width: 310px;
        margin: 0 auto;
        @include media($sm) {
            width: 450px;
        }
        @include media($md) {
            width: 650px;
        }
        @include media($lg) {
            width: 900px;
        }
        @include media($xlg) {
            width: 1000px;
        }
        @include media($xl) {
            width: 1200px;
        }
    }
</style>
